<script>
  import { fly, fade } from "svelte/transition";
  import { ScrollingDisable, ScrollingEnable } from "../library/util.js";

  let isOpen = false;

  let message = "";
  let title = "";
  let openChecker = null;
  let currentOverflowStyle = "";
  let buttonOk = "OK";
  let buttonCancel = "Cancel";
  let showButtonCancel = false;
  let okPressed = true;

  export async function showAlert(atitle, amessage, options = {}) {
    title = atitle;
    message = amessage;
    buttonOk = options.buttonOk ? options.buttonOk : "OK";
    buttonCancel = options.buttonCancel ? options.buttonCancel : "Cancel";
    showButtonCancel = false;
    return open();
  }

  export async function showConfirm(atitle, amessage, options = {}) {
    title = atitle;
    message = amessage;
    buttonOk = options.buttonOk ? options.buttonOk : "OK";
    buttonCancel = options.buttonCancel ? options.buttonCancel : "Cancel";
    showButtonCancel = true;
    return open();
  }

  async function open() {
    ScrollingDisable();
    isOpen = true;
    return new Promise(async function(resolve, reject) {
      openChecker = setInterval(() => {
        if (!isOpen) {
          clearTimeout(openChecker);
          if (okPressed) resolve(true);
          else resolve(false);
        }
      }, 500);
    });
  }

  function close(aOkPressed) {
    okPressed = aOkPressed;
    ScrollingEnable();
    isOpen = false;
  }

</script>

<style>
  .mymodal-wrapper {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1000000;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    flex-direction: row;
    justify-content: center;
  }

  .mymodal {
    position: fixed;
    left: 0;
    right: 0;
    top: 10%;
    background-color: #fafafa;
    padding: 0px 20px;
    max-height: 70%;
    width: 90%;
    margin: auto;
    overflow-y: auto;
    border-radius: 2px;
    display: flex;
    flex-direction: column;
    box-shadow: 5px 5px 15px #666;
    box-sizing: border-box;
  }
  @media only screen and (min-width: 768px) {
    .mymodal {
      width: 55%;
    }
  }

  .mymodal .header {
    height: 60px;
    display: flex;
    flex-direction: row;
    align-items: center;
    box-sizing: border-box;
  }

  .mymodal h5 {
    margin: 0;
  }

  .mymodal .content {
    height: calc(100% - 60px - 56px);
    max-height: 100%;
    width: 100%;
    overflow-y: auto;
    padding-bottom: 20px;
    box-sizing: border-box;
  }

  .mymodal .footer {
    padding: 4px 6px;
    height: 56px;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    box-sizing: border-box;
  }
</style>

{#if isOpen}
  <div class="mymodal-wrapper" transition:fade={{ duration: 250 }}>

    <div class="mymodal" transition:fly={{ y: -100, duration: 250 }}>
      <div class="header">
        <h5>
          {@html title}
        </h5>
      </div>

      <div class="content">
        {@html message}
      </div>

      <div class="footer">
        {#if showButtonCancel}
          <button on:click={() => close(false)} class="btn-flat waves-effect">
            {buttonCancel}
          </button>
        {/if}
        <button on:click={() => close(true)} class="btn-flat waves-effect">
          {buttonOk}
        </button>
      </div>
    </div>

  </div>
{/if}
